module.exports = __webpack_public_path__ + "static/media/contoh_garansi.387ab5c6.jpg";